import { Dialog as HDSDialog, DialogPanel, DialogBackdrop } from '@headlessui/react';

import { generateTestId } from './data';

export interface DialogProps {
  dataTestId: string;
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
  size?: 'extraSmall' | 'small' | 'default' | 'large' | 'full';
}

const sizeClass = {
  extraSmall: 'max-w-[480px]',
  small: 'max-w-screen-sm',
  default: 'max-w-screen-md',
  large: 'max-w-[825px]',
  full: 'w-full',
};

const Dialog = (props: DialogProps) => {
  const { dataTestId, isOpen, children, onClose, size = 'default' } = props;

  const testIds = generateTestId(dataTestId);

  return (
    <HDSDialog
      data-testid={testIds.component}
      open={isOpen}
      as='div'
      className='relative z-50 focus:outline-none'
      onClose={onClose}
    >
      <DialogBackdrop className='fixed inset-0 bg-black-900 w-screen h-screen opacity-30' />
      <div className='fixed inset-0 flex w-screen items-center justify-center p-0 md:p-4 z-30'>
        <div className={`${sizeClass[size]} w-full flex min-h-full items-center justify-center p-2 md:p-4`}>
          <DialogPanel
            transition
            className={`w-full rounded-lg shadow-md bg-white backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0 overflow-hidden`}
          >
            {children}
          </DialogPanel>
        </div>
      </div>
    </HDSDialog>
  );
};

export default Dialog;
